import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { format, parseISO } from "date-fns";
import { CalendarHeart, ArrowRight } from "lucide-react";
import { useVisitor } from "@/lib/visitor";
import { publicApi } from "@/lib/api";
import { timeLabel } from "@/components/staff/categories";

const greeting = () => {
  const h = new Date().getHours();
  return h < 12 ? "Good morning" : h < 18 ? "Good afternoon" : "Good evening";
};

export const WelcomeBack = () => {
  const { profile } = useVisitor();
  const [next, setNext] = useState(null);
  const name = profile?.nickname;
  useEffect(() => {
    const ids = JSON.parse(localStorage.getItem("vp_rsvps") || "[]");
    if (!ids.length) return;
    publicApi.get("/public/next-event", { params: { ids: ids.join(",") } }).then((r) => setNext(r.data)).catch(() => {});
  }, []);
  if (!name || !next) return null;
  return (
    <section className="mx-auto max-w-7xl px-5 pt-10 lg:px-10" data-testid="welcome-back">
      <div className="flex flex-col gap-4 rounded-3xl border border-[#D6E4F2] bg-gradient-to-r from-[#EBF3FA] to-white p-6 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <p className="text-2xl font-bold tracking-tight text-[#0A3A6B]" data-testid="welcome-back-greeting">{greeting()}, {name}! Welcome back.</p>
          <p className="mt-1 text-sm text-slate-600">We're looking forward to seeing you soon.</p>
        </div>
        <Link to={`/events/${next.id}`} className="group flex items-center gap-3 rounded-2xl bg-white p-4 shadow-sm transition-transform hover:-translate-y-0.5" data-testid="welcome-back-next-event">
            <span className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-[#0A3A6B] text-white"><CalendarHeart className="h-5 w-5" /></span>
            <span>
              <span className="block text-xs font-semibold uppercase tracking-wider text-[#1D64B4]">Your next event</span>
              <span className="block font-semibold text-slate-900">{next.title}</span>
              <span className="block text-xs text-slate-500">{format(parseISO(next.date), "EEE, MMM d")}{next.start_time && ` · ${timeLabel(next.start_time)}`}</span>
            </span>
            <ArrowRight className="h-4 w-4 text-[#1D64B4] transition-transform group-hover:translate-x-1" />
          </Link>
      </div>
    </section>
  );
};
